/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ChatResetChatPathParams, ChatResetChatResponse } from '../types/ChatResetChat'

/**
 * POST /chat/:chat/reset
 * @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::resetChat
 */
export async function chatResetChat(
	chat: ChatResetChatPathParams['chat'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ChatResetChatResponse>> {
	return axiosInstance.post(`/chat/${chat}/reset`, undefined, config)
}
